import React from 'react';
import { useTranslation } from 'react-i18next';
import { ComponentInstanceIcon } from '@radix-ui/react-icons';
import { translatePropertyChipLabel } from '@/shared/utils/property-chip-label';
import type { PropertyFilters } from './constants';
import {
  CONDO_LEISURE_OPTIONS,
  CONDO_SECURITY_OPTIONS,
  CONDO_EXPENSES_OPTIONS,
} from './constants';
import { SectionHeader, FieldLabel, ChipBtn } from './parts';

interface Props {
  filters: PropertyFilters;
  toggleInArray: (field: keyof PropertyFilters, value: string) => void;
}

/**
 * Checks whether an array-valued filter field already includes a value.
 */
const has = (filters: PropertyFilters, field: keyof PropertyFilters, value: string) =>
  ((filters[field] as string[] | undefined) || []).includes(value);

export const FilterSectionCondoAmenities: React.FC<Props> = ({ filters, toggleInArray }) => {
  const { t } = useTranslation('features/properties');
  return (
    <div>
      <SectionHeader icon={<ComponentInstanceIcon width={14} height={14} />} title={t('filterPanel.condoAmenities')} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
        <div>
          <FieldLabel>{t('filterPanel.condoLeisure')}</FieldLabel>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--space-1)' }}>
            {CONDO_LEISURE_OPTIONS.map((token) => (
              <ChipBtn key={token} value={translatePropertyChipLabel(t, token)} active={has(filters, 'condoLeisure', token)} onClick={() => toggleInArray('condoLeisure', token)} />
            ))}
          </div>
        </div>
        <div>
          <FieldLabel>{t('filterPanel.condoSecurity')}</FieldLabel>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--space-1)' }}>
            {CONDO_SECURITY_OPTIONS.map((token) => (
              <ChipBtn key={token} value={translatePropertyChipLabel(t, token)} active={has(filters, 'condoSecurity', token)} onClick={() => toggleInArray('condoSecurity', token)} />
            ))}
          </div>
        </div>
        <div>
          <FieldLabel>{t('filterPanel.condoExpenses')}</FieldLabel>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--space-1)' }}>
            {CONDO_EXPENSES_OPTIONS.map((token) => (
              <ChipBtn key={token} value={translatePropertyChipLabel(t, token)} active={has(filters, 'condoExpenses', token)} onClick={() => toggleInArray('condoExpenses', token)} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
